export default __webpack_public_path__ + "static/media/162727358_108674267973762_4668352915600317345_n.ae0de9c7.jpg";